import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@material-ui/core";

function OppMasterMerchantButton(props) {
  return (
    <Button
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 200,
        height: 200,
        border: "lightgrey 1px solid",
      }}
      onClick={() => props.onClick()}
    >
      <Typography variant={"h6"}>{props.oppMasterMerchant.name}</Typography>
    </Button>
  );
}

OppMasterMerchantButton.propTypes = {
  oppMasterMerchant: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default OppMasterMerchantButton;
